<template>
  <form-panel
    :title="update ? 'Editar' : 'Nuevo' + ' seguimiento'"
    width="medium"
    @closePanel="onCloseModal">
    <trackings-form
      :current-opportunity="opportunity"
      :update="update"
      :customer="customer"
      :is-final="isFinal"/>
  </form-panel>
</template>

<script>
import FormPanel from '@/components/_shared/form-panel'
import TrackingsForm from '@/modules/trackings/trackings-form'

export default {
  name: 'TrancingsCreateView',
  components: {
    TrackingsForm,
    FormPanel
  },
  props: {
    opportunity: {
      type: Object,
      default: null
    },
    update: {
      type: Boolean,
      default: false
    },
    isFinal: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    customer () {
      return this.$store.getters['customers/item']
    }
  },
  methods: {
    onCloseModal () {
      this.$store.dispatch('app/toggleTrackingPanel')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/app/tracings/tracings-create-view.vue